import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ProtectedRoute } from '../components/auth/index.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business コーディング規約 wiki レイアウト。wiki 関連ページの Outlet ラッパー
 * @graph-connects none
 */
export const Route = createFileRoute('/knowledge-wiki')({
  component: KnowledgeWikiLayout,
});

/**
 * コーディング規約 wiki レイアウトラッパー
 * @graph-connects ProtectedRoute [calls] PI Div 所属または admin に限定してアクセスをガードする
 */
function KnowledgeWikiLayout() {
  return (
    <ProtectedRoute pageKey="knowledgeWiki">
      <Outlet />
    </ProtectedRoute>
  );
}
